import { Component, Input } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';

export interface MessageComponentData {
    type: string;
    header: string;
    content: string | null;
}

@Component({
  selector: 'app-message',
  imports: [TegelModule],
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss'
})
export class MessageComponent {
  @Input() message!: MessageComponentData | null;
}
